export const searchTerms = [
  'resource',
  'bpmn',
  'call activity',
  'child process'
].join(' ');
